// extracted by mini-css-extract-plugin
export default {"buttonSeven":"buttonSeven_buttonSeven__FvUNl"};